import FaqTopic from './FaqTopic'

export default FaqTopic